<!--
 * @LastEditors: zhanglinju
-->
<!--
 * @LastEditors: zhanglinju
-->
<template>
  <div class="lebals">
    <div v-if="showqq">
      <a
        href="https://admin.qidian.qq.com/template/blue/mp/menu/qr-code-jump.html?linkType=0&env=ol&kfuin=2885871656&fid=5819&key=488b11e6cf63f5a0392bb2d6ace30e27&cate=1&type=16&ftype=1&_type=wpa&qidian=true"
        class="contact"
      >
        <img
          src="../../../assets/icon/btn_qq.png"
          alt=""
        >
        <span>购买咨询</span>
      </a>
    </div>
    <div v-if="showdz">
      <a
        href="https://services.youxuepai.com/branches/mobile/"
        class="contact"
      >
        <img
          src="../../../assets/icon/btn_wd.png"
          alt=""
        >
        <span>网点查询</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Lebals',
    components: {},
    props: {
        showqq: {
            default: false,
            type: Boolean,
        },
        showdz: {
            default: false,
            type: Boolean,
        },
    },
    data () {
        return {};
    },

    methods: {},
};
</script>
<style lang='scss' scoped>
.lebals {
  position: fixed;
  right: 10px;
  bottom: 20px;
  z-index: 1000;
  .contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
    }
    span {
      color: black;
    }
  }
}
</style>
